import { useEffect, useState } from "react";
import { getIndustry } from "../services/industryService";
import { saveCompanyDetail } from "../services/companyService";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import { useToast } from "../context/ToastContext";

function CreateCompanyProfile() {
  const navigate = useNavigate();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    registeredName: "",
    industryId: "", // changed from array to string
    contactNumber: "",
    emailAddress: "",
    websiteUrl: "",
  });

  const getIndustries = async () => {
    const res = await getIndustry();
    //console.log(res);
    if (res && res.success === false) {
      throw new Error(res.message || "Password update failed.");
    }
    const items = Array.isArray(res) ? res : res.data;
    setIndustries(items || []);
  };

  useEffect(() => {
    getIndustries();
    // fetch("/api/industry/get")
    //   .then((res) => res.json())
    //   .then((data) => {
    //     const items = Array.isArray(data) ? data : data.data;
    //     console.log("Fetched industries:", data);
    //     setIndustries(items || []);
    //   })
    //   .catch((err) => console.error("Industry fetch error", err));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    if (!formData.industryId) {
      // alert("Please select an industry.");
      toast.warning("Please select an industry.");
      setIsLoading(false);
      return;
    }

    const payload = {
      name: formData.name,
      registeredName: formData.registeredName,
      industryIds: [parseInt(formData.industryId)],
      contactNumber: formData.contactNumber,
      emailAddress: formData.emailAddress,
      websiteUrl: formData.websiteUrl,
    };

    try {
      // const response = await fetch("/api/company", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(payload),
      // });

      // const result = await response.json();

      const respones = await saveCompanyDetail(payload);
      const result = respones;

      if (respones.status) {
        // alert("Company profile created!");
        toast.success("Company profile created!");
        setFormData({
          name: "",
          registeredName: "",
          industryId: "", // reset to string
          contactNumber: "",
          emailAddress: "",
          websiteUrl: "",
        });
        navigate("/unassigned-companies");
        setIsLoading(false);
      } else {
        // alert(`Error: ${result.message || "Company creation failed."}`);
        toast.error(`Error: ${result.message || "Company creation failed."}`);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      console.error(err);
      alert("Failed to create company.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-2 gap-6 bg-white p-6 rounded-xl shadow border"
    >
      <div>
        <label className="block mb-1 font-medium">Company Name:</label>
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter Company Name"
          className="w-full px-4 py-2 border rounded"
          required
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Registered Name:</label>
        <input
          name="registeredName"
          value={formData.registeredName}
          onChange={handleChange}
          placeholder="Legal Registered Name"
          className="w-full px-4 py-2 border rounded"
          required
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Industry:</label>
        <select
          name="industryId"
          value={formData.industryId}
          onChange={handleChange}
          className="w-full px-4 py-2 border rounded"
          required
        >
          <option value="" className="text-black">
            Select Industry
          </option>
          {industries &&
            industries.length > 0 &&
            industries.map((industry) => (
              <option key={industry.id} value={industry.id}>
                {industry.value}
              </option>
            ))}
        </select>
      </div>

      <div>
        <label className="block mb-1 font-medium">Contact Number:</label>
        <input
          name="contactNumber"
          value={formData.contactNumber}
          onChange={handleChange}
          placeholder="+91 00000 00000"
          className="w-full px-4 py-2 border rounded"
          required
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Email Address:</label>
        <input
          name="emailAddress"
          type="email"
          value={formData.emailAddress}
          onChange={handleChange}
          placeholder="example@company.com"
          className="w-full px-4 py-2 border rounded"
          required
        />
      </div>

      <div>
        <label className="block mb-1 font-medium">Website:</label>
        <input
          name="websiteUrl"
          value={formData.websiteUrl}
          onChange={handleChange}
          placeholder="https://example.com"
          className="w-full px-4 py-2 border rounded"
        />
      </div>

      <div className="col-span-2 text-right">
        <button
          type="submit"
          className="bg-[#6f81f5] text-white px-6 py-3 rounded-lg hover:opacity-90"
        >
          {isLoading ? (
            <Loading message="" size="sm" loaderColor="white" />
          ) : (
            "Create profile →"
          )}
        </button>
      </div>
    </form>
  );
}

export default CreateCompanyProfile;
